<template>
    <!-- Meta Tags -->
    <Head title="Contacto" />

    <section
        class="bg-contact bg-cover bg-center w-full min-h-screenheaderfooter flex justify-center items-center"
        id="main-content"
    >
        <div class="container py-16">
            <nav class="flex" aria-label="Breadcrumb">
                <ol class="inline-flex items-center space-x-1 md:space-x-2">
                    <li class="inline-flex items-center">
                        <Link
                            href="/"
                            class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-4 h-4 mr-2"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                ></path>
                            </svg>
                            Inicio
                        </Link>
                    </li>
                    <li aria-current="page">
                        <div class="flex items-center">
                            <svg
                                aria-hidden="true"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-1 text-sm font-bold md:ml-2">Dónde comprar</span>
                        </div>
                    </li>
                </ol>
            </nav>

            <div class="w-full mx-auto mt-4">
                <h1 class="mb-4 md:mb-8 text-center uppercase">¿Donde comprar?</h1>
                <div class="flex flex-wrap justify-center items-center" ref="retailersSction">
                    <a
                        v-for="(retailer, index) in retailers"
                        :key="index"
                        :href="retailer.link"
                        target="_blank"
                        class="bg-white w-56 h-32 m-4 rounded-xl py-4 px-8"
                    >
                        <img
                            class="w-full h-full object-contain"
                            :src="`/storage/retailers/${retailer.logo}`"
                            :alt="retailer.name"
                        />
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    name: "Retailers",
    props: ["retailers", "errors"],
    data() {
        return {
            form: this.$inertia.form({
                name: null,
                email: null,
                subject: null,
                message: null,
            }),
        };
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            this.$refs.retailersSction,
            {
                opacity: 0,
                scale: "+=0.5",
            },
            {
                scrollTrigger: {
                    trigger: this.$refs.retailersSction,
                    toggleActions: "play none none none",
                },
                opacity: 1,
                scale: "-=0.5",
                duration: 1.3,
            }
        );
    },
    methods: {
        handleForm() {
            dataLayer.push({
                event: "form_contacto",
                user_id: this.form.email,
            });
            this.form.post(this.$page.props.baseUrl + "/contacto");
        },
    },
};
</script>
<style></style>
